import {Table} from "antd";
import {getPaginationConfig} from "../../util/showAllPagination";
import {useRef} from "react";
import {useDynamicTableHeight} from "../../util/useDynamicTableHeight";


const ProjectSearchMessagesTab = ({
                                    loading,
                                    messages
                                  }) => {
  const tableContainerRef = useRef(null);
  const tableHeight = useDynamicTableHeight(tableContainerRef);

  const columns = [{
    title: "Message",
    dataIndex: 'msg'
  }];
  let dataSource = [];
  for (let i = 0; i < messages.length; i++) {
    dataSource.push({id: i, msg: messages[i]});
  }
  return (
    <>
      <Table
        ref={tableContainerRef}
        rowKey="id"
        dataSource={dataSource}
        columns={columns}
        pagination={getPaginationConfig(dataSource.length)}
        size="small"
        loading={loading}
        scroll={{y: tableHeight}}
      />
    </>
  );
};

export {ProjectSearchMessagesTab};